import React, { useState, useEffect, useRef, useMemo, memo, StrictMode, useCallback } from 'react';
import { Navbar, Container, Dropdown, Nav } from 'react-bootstrap';
import { Chip } from 'primereact';
import { Link, BrowserRouter} from 'react-router-dom';
import { useAuthentication, useApp } from '../../Hooks';
import { SettingsButton } from './SettingsButton';
import { SupportButton } from './SupportButton';
import { SwitchCompanyButton } from './SwitchCompanyButton';
import { ShortcutButton } from '../ShortcutButton/ShortcutButton';
import ToolTip from '../ToolTip/Tooltip';

const Dp = Dropdown;
export const NavBar = memo(() => {
  const [usaNomina, setUsaNomnina] = useState('');
  const [esPrueba, setEsPrueba] = useState(false);
  const [companiasPermitidas, setCompaniasPermitidas] = useState(0);
  
  const {usuario} = useAuthentication();
  const {configuration} = useApp();
  function formalizar(){
    window.location.href = '/Public/citrus_formalizar_pago_linea.aspx?Esc=1';
  }

  useEffect(() => {
      setCompaniasPermitidas(usuario?.CompaniasPermitidas?.length)
      setEsPrueba(usuario?.Compania?.Configuracion?.EsCompaniaPrueba)
      setUsaNomnina(usuario?.Compania?.UsaNomina)
  }, [usuario]);

  const openInNewTab = useCallback((url) => {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    win.focus();
  }, []);
  useEffect(() => {
    document.body.classList.add("sidebar-mini");
    document.body.classList.add("off-canvas-sidebar");
    document.body.classList.add("body");
    document.body.style.setProperty('font-family', configuration?.Vendor === 'claro' ? 'AMX' : 'Roboto', 'important');
  }, []);
  
  return (
    <React.Fragment>
      <Container fluid className="d-flex justify-content-end">
        {usuario !== null && (
          <>
            {esPrueba && configuration?.Vendor !== "claro" && (
              <Dp
                as={Nav.Item}
                style={{
                  position: 'absolute',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginRight: '20px'
                }}
              >
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-formalizar"
                  className="buttonHover"
                  onClick={(e) => {
                    e.preventDefault();
                    formalizar();
                  }}
                >
                  <ToolTip placement="left" message="Formalizar">
                    <Chip label="Formalizar" image="/img/public/sticker.png" />
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
            <ShortcutButton />
            {usaNomina && (
              <Dp as={Nav.Item}>
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-mis-solicitudes"
                  className="buttonHover"
                  onClick={(e) => {
                    e.preventDefault();
                    openInNewTab("/Nomina/mis_solicitudes.aspx");
                  }}
                >
                  <ToolTip placement="left" message="Mis Solictudes">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="34"
                      fill="#77777A"
                      height="34"
                      viewBox="0 -960 960 960"
                    >
                      <path d="M307.72-293.693q11.588 0 19.819-8.258 8.231-8.257 8.231-19.846 0-11.588-8.258-19.819-8.258-8.23-19.846-8.23-11.588 0-19.819 8.257-8.231 8.258-8.231 19.846 0 11.589 8.258 19.819 8.258 8.231 19.846 8.231Zm0-158.23q11.588 0 19.819-8.258t8.231-19.846q0-11.588-8.258-19.819t-19.846-8.231q-11.588 0-19.819 8.258t-8.231 19.846q0 11.588 8.258 19.819t19.846 8.231Zm0-158.231q11.588 0 19.819-8.257 8.231-8.258 8.231-19.846 0-11.589-8.258-19.819-8.258-8.231-19.846-8.231-11.588 0-19.819 8.258-8.231 8.257-8.231 19.846 0 11.588 8.258 19.819 8.258 8.23 19.846 8.23Zm130.434 311.076h230.538v-45.383H438.154v45.383Zm0-158.23h230.538v-45.384H438.154v45.384Zm0-158.231h230.538v-45.383H438.154v45.383Zm-240.46 475.538q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h564.612q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v564.612q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H197.694Zm0-45.384h564.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-564.612q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846Zm-12.309-589.23V-185.385-774.615Z" />
                    </svg>
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
            <Dp as={Nav.Item}>
              <Dp.Toggle
                as={Nav.Link}
                id="dropdown-documentacion"
                className="buttonHover"
                onClick={(e) => {
                  e.preventDefault();
                  openInNewTab(
                    "https://www.youtube.com/channel/UC27QBJ1F_cttXCQ2FLE5RPA/videos"
                  );
                }}
              >
                <ToolTip placement="left" message="Documentacion">
                  <svg
                    style={{ marginTop: "1.4px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    fill="#77777A"
                    height="32"
                    viewBox="0 0 196 144"
                  >
                    <g>
                      <path d="M157.0235,0H38.9763C17.4843,0,0,17.5393,0,39.0977v65.8048C0,126.4609,17.4843,144,38.9763,144h118.0472   C178.5155,144,196,126.4609,196,104.9025V39.0977C196,17.5393,178.5155,0,157.0235,0z M188,104.9025   C188,122.0489,174.1035,136,157.0235,136H38.9763C21.8963,136,8,122.0489,8,104.9025V39.0977C8,21.9513,21.8963,8,38.9763,8   h118.0472C174.1035,8,188,21.9513,188,39.0977V104.9025z" />
                      <path d="M133.4415,70.5529l-55.42-32.4612c-1.2304-0.7204-2.7655-0.7324-4.01-0.0192C72.7675,38.7853,72,40.1093,72,41.5429   v64.9144c0,1.4336,0.7675,2.7576,2.0095,3.4704c0.6172,0.3536,1.3048,0.5296,1.9905,0.5296c0.6991,0,1.3963-0.1836,2.0215-0.5488   l55.42-32.4532c1.2244-0.7168,1.9785-2.0313,1.9785-3.4513C135.42,72.584,134.668,71.2697,133.4415,70.5529z M80,99.4785V48.5217   l43.504,25.4823L80,99.4785z" />
                    </g>
                  </svg>
                </ToolTip>
              </Dp.Toggle>
            </Dp>
            {configuration?.Vendor !== "claro" && (
              <Dp as={Nav.Item}>
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-soporte-whatsapp"
                  className="buttonHover"
                  onClick={(e) => {
                    e.preventDefault();
                    openInNewTab(
                      "https://api.whatsapp.com/send?phone=18095488274"
                    );
                  }}
                >
                  <ToolTip placement="left" message="Soporte Whatsapp">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      fill="#77777A"
                      height="28"
                      viewBox="0 0 24 24"
                    >
                      <g id="whatsapp">
                        <g data-name="<Group>" id="_Group_">
                          <path
                            d="M12,.5A11.5,11.5,0,0,0,2.46,18.42L.5,23.5l5.23-1.87A11.5,11.5,0,1,0,12,.5Z"
                            data-name="<Path>"
                            id="_Path_"
                            style={{
                              fill: "none",
                              stroke: "#77777A",
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                            }}
                          />
                          <path
                            d="M9.5,14.5c1.3,1.3,4.17,3,5.5,3a2.53,2.53,0,0,0,2.5-2v-1s-1.23-.6-2-1-2,1-2,1A6.52,6.52,0,0,1,11,13a6.52,6.52,0,0,1-1.5-2.5s1.4-1.23,1-2-1-2-1-2h-1A2.53,2.53,0,0,0,6.5,9C6.5,10.33,8.2,13.2,9.5,14.5Z"
                            data-name="<Path>"
                            id="_Path_2"
                            style={{
                              fill: "none",
                              stroke: "#77777A",
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                            }}
                          />
                        </g>
                      </g>
                    </svg>
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
              <SupportButton />
              {companiasPermitidas > 1 && (
              <SwitchCompanyButton/>
            )}
            <SettingsButton usuario={usuario}/>
          </>
        )}
      </Container>
    </React.Fragment>
  );
});
